import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-location-browse-input",
  templateUrl: "./location-browse-input.component.html",
  styleUrls: ["./location-browse-input.component.scss"],
})
export class LocationBrowseInputComponent {
  @Input() label: string = "Location";
  @Input() placeholder: string = "My Experiments";
  @Input() selectedPath: string = "";
  @Input() tooltip: string = "Browse Location";
  @Input() tooltipPosition: string = "top";
  @Input() iconSrc: string = "/assets/images/icon-folder.svg";
  @Input() iconAlt: string = "Browse";
  @Output() onBrowseClick = new EventEmitter<void>();

  handleBrowseClick(): void {
    this.onBrowseClick.emit();
  }

  get displayPath(): string {
    return this.selectedPath || this.placeholder;
  }
}
